import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./lang";
import "react-toastify/dist/ReactToastify.css";
import {
  env,
  datadogApplicationId,
  clientToken,
} from "./config";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { datadog_site } from "./constants/datadog";
import packageInfo from "../package.json";

//initialize Datadog
datadogRum.init({
  applicationId: datadogApplicationId ?? "",
  clientToken: clientToken ?? "",
  site: datadog_site,
  service: packageInfo.name,
  env: env,
  version: packageInfo.version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: "allow",
  plugins: [reactPlugin({ router: true })],
});


let refreshing = false;
navigator.serviceWorker.addEventListener('controllerchange', () => {
  console.log("start controllerchange event")
  if (!refreshing) {
    console.log("refreshing is false, start refresh")
    refreshing = true;
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const event = new CustomEvent("PWA_UPDATE_AVAILABLE", {
      detail: registration,
    });
    window.dispatchEvent(event);
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
